import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';
import { MenuService } from '@services/seguridad/menu/menu.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogDeleteMenuComponent } from './dialog-delete-menu/dialog-delete-menu.component';

@Component({
  selector: 'app-eliminar-menu',
  templateUrl: './eliminar-menu.component.html',
  styleUrls: ['./eliminar-menu.component.css']
})
export class EliminarMenuComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogDeleteMenuComponent>,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private menuService: MenuService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
  }

  doAction() {
    this.delete(this.data.id)
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  delete(id: number) {
    this.spinner.show("spEliminarMenu")
    this.menuService.delete(id)
      .subscribe(
        data => {
          this.spinner.hide("spEliminarMenu")
          this.snackBar.showSuccess("Registro eliminado correctamente.", "Exito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar });
        },
        error => {
          this.spinner.hide("spEliminarMenu")
          this.snackBar.showError(error, "Error");
        }
      )
  }
  trackByItems(index: number, item: any): any { return item; }

}
